module.exports = new __parcel__URL__("isoft-icon.8b8ccd27.jpg").toString();